import React, { useEffect, useState } from "react";
import { Select } from "antd";
import Header from "../../Header/Header";
import SideBar from "../../SideBar/SideBar";
import { Link } from "react-router-dom";
import Pagination from "../../pages/Base UI/Pagination";
import "./adminstudent.css";
import Footer from "../../Footer/Footer";
import { Avatar, Space, Table, Tag } from "antd";
import Table1 from "./Table1";
import {
  AssignApplicationToTeam,
  getAllApplicationTeams,
  getAllApplicationTeamsByTeamId,
  getAllApplications,
  getAllApplicationsBasedOnStatus,
  getTeamApplicationsWithId,
  getTeamBasedOnUserId,
  searchOnApplications,
} from "../../HttpRequest/applyapplication";
import { registersuccess } from "../../SweetAlert/SweetAlert";
import { genericSearch } from "../../HttpRequest/searchcalls";
import Loading from "../Reusecomponent/Loading";

export default function Adminstudentview() {
  const [SearchingData, setSearchingData] = useState({});
  const [loading, setLoading] = useState(false);
  const [Applications, setApplications] = useState([]);
  const [ApplicationsInfo, setApplicationsInfo] = useState([]);
  const [teamName, setTeamname] = useState([]);
  const [checkedIndex, setCheckedIndex] = useState(1);
  const [Applicationteams, setApplicationteams] = useState([]);
  const [loginUserRole, setloginUserRole] = useState("");
  const [pagedata, setPageData] = useState();
  const [universityOptions, setUniversityOptions] = useState();
  const { Option } = Select;
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });

  const setPageInfoData = (data) => {
    console.log("page data to parent-->", data);
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };

  useEffect(() => {
    const storedRole = sessionStorage.getItem("userRole") || localStorage.getItem("userRole");
    const loginUserId = sessionStorage.getItem("id") || localStorage.getItem("id");
    if (storedRole) {
      setloginUserRole(storedRole);
      console.log("Role is found-->", loginUserRole);
      if (storedRole == "admin") {
        getAdminApplications();
        getAllTeams();
      } else if (storedRole == "application-assistant") {
        getTeamBasedOnUser(loginUserId);
        // getTeamApplications();
      } else {
        console.log("Unknown user role");
      }
    } else {
      console.log("Role is not found-->");
    }
  }, [pageInfo]);

  const getAdminApplications = () => {
    getAllApplications(pageInfo.page, pageInfo.size).then((response) => {
      setLoading(true);
      console.log("applications response", response.data.data);
      setApplications(response.data.data);
      setApplicationsInfo(response.data.data);
      setCheckedIndex(1);
      // setInfo(response.data.data.map((item) => item.university));
      console.log("Infomartion",response.data.data)
      setPageData(response.data.metaData);
      setTimeout(() => {
        setLoading(false);
      }, 1400);
    });
    console.log("application files data->", Applications);
  };
  const filterApplicationsBasedOnStatus = async (index, Status) => {
    getAllApplicationsBasedOnStatus(Status, pageInfo.page, pageInfo.size).then(
      (response) => {
        console.log("filter responce-->", response);
        if (response.request.status == 200 || response.request.status == 201) {
          setPageData(response.data.metaData);
          setApplications(response.data.data);
          console.log("ResponseStatus", response.data.data);
          setCheckedIndex(index);
        }
      }
    );
  };
  const getTeamBasedOnUser = (userId) => {
    getTeamBasedOnUserId(userId).then((response) => {
      // console.log("team response", response.data[0].id);
      getTeamApplications(response.data[0].id);
      getAllTeams();
    });
  };
  const getAllTeams = () => {
    getAllApplicationTeams().then((response) => {
      console.log("applications teams response", response.data.data);
      setApplicationteams(response.data.data);
    });
  };

  const assigTeamApplications = (data, id) => {
    data.teamId = id;
    AssignApplicationToTeam(data.id, data).then((response) => {
      getAllApplicationTeamsByTeamId(response.data.teamId).then((team) => {
        registersuccess(
          "Application with Id  " +
            response.data.applicationId +
            "  was successfully assigned to team " +
            team.data.name
        );
      });
      console.log("applications teams response", response);
    });
  };

  const getTeamApplications = (teamId) => {
    getTeamApplicationsWithId(teamId, pageInfo.page, pageInfo.size).then(
      (response) => {
        console.log("applications response", response.data.data);
        setApplications(response.data.data);
        setPageData(response.data.metaData);
      }
    );
  };

  const handleInputChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setSearchingData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const dataFromChild = (data) => {
    console.log("data is trasferred to parent-->", data);
    setApplications(data);
  };

  const DynamicallyAdjustFeild = (e) => {
    const inputValue = e.target.value;
    let fieldName;
    if (inputValue.length === 10 && /^\d+$/.test(inputValue)) {
      fieldName = "phoneNumber";
    } else if (inputValue.length === 8 && /^\d+$/.test(inputValue)) {
      fieldName = "applicationId";
    } else if (/^\S+@\S+\.\S+$/.test(inputValue)) {
      fieldName = "email";
    } else {
      fieldName = "firstName";
    }
    setSearchingData((prevData) => ({
      ...prevData,
      [fieldName]: inputValue,
    }));
  };

  const applicationFilter = async () => {
    console.log("search calling-->", SearchingData);
    if (SearchingData === null) {
      getAdminApplications();
    }
    try {
      setLoading(true);
      let status ="";
    if(checkedIndex == 2){
       status ="application-requested";
    }else if(checkedIndex ==3){
      status ="application-submitted";
    }else if(checkedIndex == 4){
      status = "reject"
    }else{
      getAdminApplications();
    } 
    // const data ={
    //   ...SearchingData,
    //   status:status,
    // }
      const response = await searchOnApplications(SearchingData);
      console.log("search result-->", response.data);
      setApplications(response.data);
      setPageData(response.metaData);
    } catch (error) {
      console.error("Error in searchOnApplications:", error);
    }finally{
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };


  
  useEffect(() => {
    genericSearch("university", "a", 0, 20).then((response) => {
      console.log("generic search result-->", response);
      const filteredData = response.map((country) => ({
        label: country.key,
        value: country.value,
      }));
      setUniversityOptions(filteredData);
    });
  }, []);




  const handleUniversityChange = (value) => {
      console.log("search apiii:", value);
      genericSearch('university', value, 0, 20).then((response) => {
        console.log("generic search result-->", response);
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setUniversityOptions(filteredData);
      });
  };
  const [selectedOption, setSelectedOption] = useState("");

  const setIntakes = [
    { key: "Fall", value: "Fall" },
    { key: "Spring", value: "Spring" },
    { key: "Summer", value: "Summer" },
    { key: "Jan", value: "Jan" },
    { key: "Feb", value: "Feb" },
    { key: "Mar", value: "Mar" },
    { key: "Apr", value: "Apr" },
    { key: "May", value: "May" },
    { key: "June", value: "June" },
    { key: "July", value: "July" },
    { key: "Aug", value: "Aug" },
    { key: "Sep", value: "Sep" },
    { key: "Oct", value: "Oct" },
    { key: "Nov", value: "Nov" },
    { key: "Dec", value: "Dec" },
  ];
  const setStatus = [
    "application-requested",
    "application-pending",
    "missing-documents",
    "approve-assign",
    "reject",
    "admit-received",
    "admit-rejected",
    "process-i-20",
    "i-20-process-completed",
    "i-20-received",
    "ds-160-sevis-pending",
    "ds-160-sevis-completed",
    "visa-slot-booked",
    "visa-processing",
    "visa-received",
    "visa-rejected",
    "case-closed",
  ];

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const filterOption = (input, option) => {
    return false;
  };




  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">All Applications </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Applications</li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="checkboxgroup"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 1}
                  onClick={() => {
                    getAdminApplications();
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  All
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 2}
                  onClick={() => {
                    filterApplicationsBasedOnStatus(2, "application-requested");
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  Waiting for Approval
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 3}
                  onClick={() => {
                    filterApplicationsBasedOnStatus(3, "application-submitted");
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  Pending
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 4}
                  onClick={() => {
                    filterApplicationsBasedOnStatus(4, "reject");
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  Completed
                </label>
              </div>
            </div>
            <div className="carddesing m-1">
           <div class="card appcaltioncard appcaltioncardsearch" >
                <div className="applicationviewcardgrid">
                  <input
                    className="gridsearchinput"
                    type="text"
                    placeholder="student Id / Name /Email/Phone Number / Application ID"
                    onChange={DynamicallyAdjustFeild}
                  />
                  <div className="gridsearchinput  gridsearchinputt">
                    {/* <input
                      className="gridsearchinput"
                      type="text"
                      placeholder="University"
                      name="universityName"
                      value={SearchingData.universityName}
                      onChange={handleInputChange}
                    />
                    
                    <input
                      className="gridsearchinput"
                      type="text"
                      placeholder="Country"
                      name="country"
                      value={SearchingData.country}
                      onChange={handleInputChange}
                    />
                    <input
                      className="gridsearchinput"
                      type="text"
                      placeholder="Intake"
                      name="intakes"
                      value={SearchingData.intakes}
                      onChange={handleInputChange}
                    />
                    <input
                      className="gridsearchinput"
                      type="text"
                      placeholder="Status"
                      name="status"
                      value={SearchingData.status}
                      onChange={handleInputChange}
                    /> */}
                    {/* <div> */}
                    {/* <Select></Select> */}
                    {/* <Select
                        className="gridsearchinput"
                        name="country"
                        placeholder={"Country"}
                        value={SearchingData.country}
                        onChange={(value, option) => handleInputChange({ target: { name: 'country', value } })}                                         
                      >
                        {selectedOption === "" && (
                          <option value="" disabled hidden>
                            Country
                          </option>
                        )}
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="United States Of America">United States Of America</option>
                        <option value="Canada">Canda</option>
                        <option value="Australia">Australia</option>
                        <option value="Finland">Finland</option>
                        <option value="New Zealand">New Zealand</option>
                      </Select> */}
                    {/* <input
                      className="gridsearchinput"
                      placeholder="Country"
                      onChange={(e) => handleInputChange(e.target.value)}
                    /> */}
                    <Select
                      className="gridsearchinput"
                      showSearch
                      placeholder="Country"
                      optionFilterProp="children"
                      value={SearchingData.country || undefined}
                      onChange={(value, option) =>
                        handleInputChange({
                          target: { name: "country", value },
                        })
                      }
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option value="United Kingdom">United Kingdom</Option>
                      <Option value="United States Of America">
                        United States Of America
                      </Option>
                      <Option value="Canada">Canada</Option>
                      <Option value="Australia">Australia</Option>
                      <Option value="Finland">Finland</Option>
                      <Option value="New Zealand">New Zealand</Option>
                    </Select>

                    <Select
                      className="gridsearchinput"
                      showSearch
                      name="universityName"
                      placeholder="University"
                      value={SearchingData.universityName || undefined}
                      onSearch={handleUniversityChange}
                      onChange={(value) =>
                        handleInputChange({
                          target: { name: "universityName", value },
                        })
                      }
                      options={universityOptions}
                    >
                    </Select>

                    <Select
                      className="gridsearchinput"
                      name="intakes"
                      showSearch
                      placeholder="Intake"
                      value={SearchingData.intakes || undefined}
                      onChange={(value, option) =>
                        handleInputChange({
                          target: { name: "intakes", value },
                        })
                      }
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setSelectedOption("");
                        }
                      }}
                      filterOption={(input, option) =>
                        option.children &&
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {setIntakes.map((intakeOption) => (
                        <Option
                          key={intakeOption.key}
                          value={intakeOption.value}
                        >
                          {intakeOption.value}
                        </Option>
                      ))}
                    </Select>

                    <Select
                      className="gridsearchinput"
                      showSearch
                      name="status"
                      placeholder="Status"
                      value={SearchingData.status || undefined}
                      onChange={(value, option) =>
                        handleInputChange({ target: { name: "status", value } })
                      }
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setSelectedOption("");
                        }
                      }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {setStatus.map((statusOption) => (
                        <Option key={statusOption} value={statusOption}>
                          {statusOption}
                        </Option>
                      ))}
                    </Select>
                    {/* </div> */}
                  </div>

                  <div
                    className="searchbox  searchbox11"
                    type="button"
                    onClick={() => applicationFilter()}
                  > 
                    <i className="fas fa-search"></i>
                  </div>
                </div>
              </div>

              {/* <Table columns={columns} dataSource={data} onChange={onChange} />     */}
              {/* {Applications.length > 0 && Applicationteams.length > 0 && ( */}
              {loading && <Loading/>}
              {Applicationteams &&
                Applicationteams.length > 0 && (
                  <Table1
                    applicationsdata={Applications || []}
                    teams={Applicationteams}
                    assigntoTeam={assigTeamApplications}
                    parentDataUpdating={dataFromChild}
                  />
                )}
              {pagedata?.totalPages > 1 && (
                <Pagination
                  pageResponce={pagedata}
                  pagedataToParent={setPageInfoData}
                />
              )}

              {/* <div   className='cardnivercitcopmponet'>  
<img  src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQor3aOtnvdUwbhjT1QMg4k8xSlr7w5yKd2CHeZYmGlGw&s'  alt='imagesuniverciy'  className='cardunvercityimage' />

<div  className='dataline'>
<h6>Ms mechanical engineering</h6>
<p>Oxford university</p>
</div>
<img src='https://www.pngkey.com/png/full/115-1150420_avatar-png-pic-male-avatar-icon-png.png'  alt='student'  className='containerv'  />
<div  className='dataline'>
  <p>Bharagav</p>
  <p>matta</p>
</div>
<div  className='dataline'  style={{marginLeft: '9px'}}>
  <h6>+46443654656</h6>
  <p>01-06-2020</p>
</div>
<div   style={{marginLeft: '9px'}}>
  <h6>Feb 2020</h6>

</div>
<div  className='linecontener'>
<h6>Active  </h6>
</div>
<div className='linecontener'>
<Link to="/chatsupport"><div className='chatcontaineradmin'>Chat <i class="fa-regular fa-message"></i></div></Link>
  <div className='editcontiner'><i class="fa-regular fa-pen-to-square"></i></div>
  <div className='moreconatiner'>...</div>
</div>
</div> */}

              {/* <div   className='cardnivercitcopmponet'>  
<img  src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQor3aOtnvdUwbhjT1QMg4k8xSlr7w5yKd2CHeZYmGlGw&s'  alt='imagesuniverciy'  className='cardunvercityimage' />

<div  className='dataline'>
<h6>Ms mechanical engineering</h6>
<p>Oxford university</p>
</div>
<img src='https://www.pngkey.com/png/full/115-1150420_avatar-png-pic-male-avatar-icon-png.png'  alt='student'  className='containerv'  />
<div  className='dataline'>
  <p>Bharagav</p>
  <p>matta</p>
</div>
<div  className='dataline'  style={{marginLeft: '9px'}}>
  <h6>+46443654656</h6>
  <p>01-06-2020</p>
</div>
<div   style={{marginLeft: '9px'}}>
  <h6>Feb 2020</h6>

</div>
<div  className='linecontener'>
<h6>Active  </h6>
</div>
<div className='linecontener'>
  <div className='admindashchatcontaineradmin'>Chat <i class="fa-regular fa-message"></i></div>
  <div className='editcontiner'><i class="fa-regular fa-pen-to-square"></i></div>
  <div className='moreconatiner'>...</div>
</div>
</div>
<hr></hr>
<div   className='cardnivercitcopmponet'>  
<img  src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQor3aOtnvdUwbhjT1QMg4k8xSlr7w5yKd2CHeZYmGlGw&s'  alt='imagesuniverciy'  className='cardunvercityimage' />

<div  className='dataline'>
<h6>Ms mechanical engineering</h6>
<p>Oxford university</p>
</div>
<img src='https://www.pngkey.com/png/full/115-1150420_avatar-png-pic-male-avatar-icon-png.png'  alt='student'  className='containerv'  />
<div  className='dataline'>
  <p>Bharagav</p>
  <p>matta</p>
</div>
<div  className='dataline'  style={{marginLeft: '9px'}}>
  <h6>+46443654656</h6>
  <p>01-06-2020</p>
</div>
<div   style={{marginLeft: '9px'}}>
  <h6>Feb 2020</h6>

</div>
<div  className='linecontener'>
<h6>Active  </h6>
</div>
<div className='linecontener'>
  <div className='chatcontaineradmin'>Chat <i class="fa-regular fa-message"></i></div>
  <div className='editcontiner'><i class="fa-regular fa-pen-to-square"></i></div>
  <div className='moreconatiner'>...</div>
</div>
</div>
<hr></hr> */}
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
